<template>
  <v-chip small>
    <router-link
      :to="{ path: `/clients/${clientId}` }"
      class="text-decoration-none"
    >
      {{ clientName }}
    </router-link>
  </v-chip>
</template>

<script>
export default {
  props: {
    clientId: [String, Number],
    clientName: String,
  },
};
</script>
